export const RETRY_FETCH = 'loyalties/RETRY_FETCH';

export const CANCEL_SUB = 'loyalties/CANCEL_SUB';
